import React from "react";
import {
  SearchOutlined,
  EyeOutlined,
  ExportOutlined,
  CloseOutlined,
  CheckOutlined,
  HourglassOutlined,
  DownloadOutlined,
  SelectOutlined,
  PrinterOutlined,
  LeftOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  WarningFilled,
  RightOutlined,
} from "@ant-design/icons";
import { Modal } from "antd";
const ExperiencePopUp = ({
  customAlert: { mappingId, key, show },
  setCustomAlert,
  unSendProfessionalForm,
  handleAlert,
}) => {
  return (
    <Modal
      title=""
      zIndex={9}
      className="p-0 custom_modal__"
      centered
      open={show}
      width={600}
      closeIcon={<CloseOutlined style={{ color: "white", fontSize: "16px" }} />}
      footer={null}
      onCancel={() =>
        setCustomAlert({
          show: false,
          mappingId: "",
          key: "",
        })
      }
    >
      <div>
        <div className="modal-header d-flex justify-content-between align-items-center active-color-modal text-white w-100">
          <h5
            className="modal-title text-white text-capitalize font-weight-bold"
            style={{ fontSize: "18px", fontWeight: 400 }}
          >
            Professional Experience
          </h5>
        </div>
        <div className="row py-3 px-4 ">
          <div className="w-100">
            <div className="col-12 p-3">
              <div className="d-flex __custom_row">
                <div style={{ flex: "1 1" }}>
                  <h4
                    className="__custom_heading text-center"
                    style={{ marginTop: "1rem" }}
                  >
                    Are you an Experienced Professional?
                  </h4>
                  <div
                    className="d-flex justify-content-center gap-1"
                    style={{
                      marginTop: "2.5rem",
                      paddingBottom: "2.5rem",
                      borderBottom: "1px solid grey",
                    }}
                  >
                    <button
                      className={`__btn px-3 text-white rounded font-weight-bold __initial_accepted`}
                      onClick={() => {
                        handleAlert(key);
                        setCustomAlert({
                          show: false,
                          mappingId: "",
                          key: "",
                        });
                      }}
                    >
                      {" "}
                      <CheckOutlined
                        style={{
                          borderRadius: "50%",
                          padding: 2,
                          marginRight: "5px",
                        }}
                        className={"__initial_accepted_icon"}
                      />
                      Yes, Experienced
                    </button>
                    <button
                      className={`__btn px-3 text-white rounded font-weight-bold __initial_rejected`}
                      onClick={async () => {
                        await unSendProfessionalForm(mappingId);
                        setCustomAlert({
                          show: false,
                          mappingId: "",
                          key: "",
                        });
                      }}
                    >
                      <CloseOutlined
                        style={{
                          borderRadius: "50%",
                          padding: 2,
                          marginRight: "5px",
                        }}
                        className={"__initial_rejected_icon"}
                      />
                      No, Fresher
                    </button>
                  </div>
                  <div className="px-2">
                    <p
                      className="font-weight-bold text-muted"
                      style={{ marginTop: "2rem" }}
                    >
                      Your Professional Experience will only be officially recognized if you have the following documents readily available for verification:
                    </p>
                    <div>
                      <ul className="px-4">
                        <li>Offer letter or Appointment letter</li>
                        <li>Experience Letter or Relieving Letter</li>
                        <li>Last 3 months' Salary Slips or Bank Statement</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExperiencePopUp;
